var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"content-info-links"},_vm._l((_vm.links),function(link){return _c('li',{key:link.to,staticClass:"content-info-links__item"},[_c('nuxt-link',{staticClass:"content-info-links__link",attrs:{"to":link.to}},[_vm._v("\n      "+_vm._s(link.title)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }